import { castArray, compact } from 'lodash';

import {
  DISCOUNT_CODE_PARAM_KEY,
  REFERRAL_CODE_PARAM_KEY,
  USER_EMAIL_PARAM_KEY,
  USER_NAME_PARAM_KEY,
  ZIP_CODE_PARAM_KEY,
  TAG_ID,
} from './constants';

export interface SystemQueryParams {
  referralCode?: string | null;
  discountCode?: string | null;
  zipCode?: string | null;
  name?: string | null;
  email?: string | null;
  preselectedFilters?: {
    tagId?: number | null;
  };
}
/**
 * Lil util for parsing and return in an object some query params we use in our system
 * @param queryParams
 * @returns
 */
export const parseAndReturnSystemParams = (
  queryParams: Record<string, string | string[] | undefined> | null,
): SystemQueryParams => {
  if (!queryParams) {
    return {};
  }

  const referralCode =
    queryParams[REFERRAL_CODE_PARAM_KEY] &&
    compact(castArray(queryParams[REFERRAL_CODE_PARAM_KEY]))[0];
  const discountCode =
    queryParams[DISCOUNT_CODE_PARAM_KEY] &&
    compact(castArray(queryParams[DISCOUNT_CODE_PARAM_KEY]))[0];
  const zipCode =
    queryParams[ZIP_CODE_PARAM_KEY] &&
    compact(castArray(queryParams[ZIP_CODE_PARAM_KEY]))[0];
  const name =
    queryParams[USER_NAME_PARAM_KEY] &&
    compact(castArray(queryParams[USER_NAME_PARAM_KEY]))[0];
  const email =
    queryParams[USER_EMAIL_PARAM_KEY] &&
    compact(castArray(queryParams[USER_EMAIL_PARAM_KEY]))[0];
  const tagId =
    queryParams[TAG_ID] && Number(compact(castArray(queryParams[TAG_ID]))[0]);

  // Can be extended when we have more preselected filters
  const hasPreselectedFilters = tagId !== undefined;

  return {
    ...(referralCode && { referralCode }),
    ...(discountCode && { discountCode }),
    ...(zipCode && { zipCode }),
    ...(name && { name }),
    ...(email && { email }),
    ...(hasPreselectedFilters && {
      preselectedFilters: {
        ...(tagId && {
          tagId,
        }),
      },
    }),
  };
};

/**
 * Clean query params from falsy values
 * @param queryParams
 * @returns
 */
export const cleanQueryParams = (
  queryParams: Record<string, string | string[] | undefined> | null,
) => {
  let cleanQueryParams = null;
  if (queryParams && Object.entries(queryParams).length > 0) {
    //Gets object from iterating over tuples conformed of query params KVs, and filtering KV with falsy values out
    cleanQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(
        ([_key, value]) => value && value !== '',
      ),
    ) as Record<string, string | string[]>;
  }
  return cleanQueryParams ? cleanQueryParams : {};
};
